import { render, staticRenderFns } from "./ServiceInformation.vue?vue&type=template&id=74f5dfb6"
import script from "./ServiceInformation.vue?vue&type=script&lang=js"
export * from "./ServiceInformation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports